/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let loginurl = root.loginUrl.link;
let loginotpurl = root.loginOtpUrl.link;
let acuserurl = root.acUserUrl.link;
let userLoginDetailsURL = root.userLoginDetailsUrl.link;
let newUserRegisteredURL = root.newUserRegisteredUrl.link;
let newSignupedUserListURL = root.newSignupedUserListUrl.link;
let professionCategoriesListURL = root.professionCategoriesListUrl.link;
let newUserVerificationUrl = root.newUserVerificationUrl.link;
let unsbcrbUserApiUrl = root.unsbcrbUserApiUrl.link;
let selfUserActivityTrackerApiUrl = root.selfUserActivityTrackerApiUrl.link;
let userLogoutApiUrl = root.userLogoutApiUrl.link;
let loginUserApiUrl = root.loginUserApiUrl.link;
let timeSlotsForDemoApiUrl = root.timeSlotsForDemoApiUrl.link;
let requestForDemoApiUrl = root.requestForDemoApiUrl.link;
let timeSlotsConvertedApiUrl = root.timeSlotsConvertedApiUrl.link;
export default {
  state: {
    token: localStorage.getItem('token'),
    status: '',
    selfUserInfoState: '',
    selfUserStatus: {
      is_online: false,
      current_status: '',
      userID: '',
      device_type: ''
    },
    signUpedUserListState:'',
  },
  mutations: {
    authSuccess(state, token) {
      state.token = token;
      state.status = 'success';
    },
    authError(state) {
      state.token = '';
      state.status = 'error';
    },
    authLogout(state) {
      state.token = '';
      state.status = '';
    },
    signUpedUserListMut(state, value) {
      Vue.set(state, 'signUpedUserListState', value);
    },
    SET_CURRENT_USER_INFO(state, value) {
      state.selfUserInfoState = value;
    },

    UPDATE_SELF_USER_STATUS(state, payload) {
      state.selfUserStatus.is_online = payload.is_online || state.selfUserStatus.is_online; 
      state.selfUserStatus.current_status = payload.current_status || state.selfUserStatus.current_status; 
      state.selfUserStatus.userID = payload.userID || state.selfUserStatus.userID;
      state.selfUserStatus.device_type = payload.device_type || state.selfUserStatus.device_type;
    },
  },
  actions: {
    alreadyBookedSlotListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(requestForDemoApiUrl).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getTimeSlotsWithZoneAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(timeSlotsConvertedApiUrl).then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getTimeSlotsforDemoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(timeSlotsForDemoApiUrl).then(
            (response) => {
              resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    loginUserWithPwAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginUserApiUrl, payload)
          .then((response) => {
            context.commit('authSuccess', response.data.data.token);
            localStorage.setItem('LoginedUserID', response.data.data.user.id);
            localStorage.setItem('token', response.data.data.token);
            axios.defaults.headers.common['Authorization'] = "Token " + response.data.data.token;
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            resolve(response);
          })
          .catch((error) => {
            localStorage.removeItem('token');
            context.commit('authError');
            reject(error);
          })
      })
    },
    selfUserActivityTrackerMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(selfUserActivityTrackerApiUrl, payload).then(
            (response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
      })
    },
    unsbcrbUserFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(unsbcrbUserApiUrl + payload.id + '/').then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    newUserVerificationFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(newUserVerificationUrl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    checkUserLoginDetails(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(userLoginDetailsURL, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    checkLoginType(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginurl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    loginWithOtp(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(loginotpurl, payload)
          .then((response) => {
            context.commit('authSuccess', response.data.data.token);
            localStorage.setItem('LoginedUserID', response.data.data.user.id);
            localStorage.setItem('token', response.data.data.token);
            axios.defaults.headers.common['Authorization'] = "Token " + response.data.data.token;
            axios.defaults.headers.post['Content-Type'] = 'application/json';
            resolve(response);
          })
          .catch((error) => {
            localStorage.removeItem('token');
            context.commit('authError');
            reject(error);
          })
      })
    },
    logoutManual(context) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token');
        localStorage.removeItem('LoginedUserID');
        localStorage.removeItem('userAgreementState');
        delete axios.defaults.headers.common['Authorization'];
        window.location.href = '/';
        // context.commit('authLogout');
        resolve();
      })
    },
    logoutAction(context) {
      return new Promise((resolve, reject) => {
        let payload = {
          type: "web"
        }
        axios.post(userLogoutApiUrl, payload)
          .then((response) => {
            window.location.href = '/';
            localStorage.removeItem('token');
            localStorage.removeItem('LoginedUserID');
            localStorage.removeItem('userAgreementState');
            delete axios.defaults.headers.common['Authorization'];
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getAuthHeader() {
      return {
        'Authorization': 'Token ' + localStorage.getItem('token')
      }
    },
    // Get Data Well Task Details
    fetchCurrentUserInfo(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(acuserurl, payload).then(res => {
              context.commit('SET_CURRENT_USER_INFO', res.data);
              resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    NewUserSignUpFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(newUserRegisteredURL, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getListOfSignupedUserFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(newSignupedUserListURL).then(
            (response) => {
              context.commit('signUpedUserListMut', response.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getProfessionCategoriesListFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(professionCategoriesListURL).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    isAuthenticated: state => !!state.token && !!localStorage.getItem('LoginedUserID'),
    authStatus: state => state.status,
    selfUserInfoGetters: state => state.selfUserInfoState,
    signUpedUsersListGetters: state => state.signUpedUserListState,
    selfUserStatusGetters: state => state.selfUserStatus,
  }
}